import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import SecondaryNavLayout from "../../../Layout/SecondaryNavLayout";
import FAIcon from "../../../UI/FAIcon/FAIcon";
import SearchWithQuery from "../../../UI/SearchWithQuery/SearchWithQuery";
import useParams from "../../../Hooks/useParams";
import useService from "../../../Hooks/useService";
import MessageService from "../../../../Services/Message.service";
import Loading from "../../../UI/Loading/Loading";
import ServiceResult from "../../../UI/ServiceResult/ServiceResult";
import { AlertError } from "../../../UI/StandardAlerts/StandardAlerts";
import { getMessageTemplateDetailView, getMessageTemplateNewPath, } from "../../../Pages/Message/MessageRoutes/MessageRoutes";
import SecondarySidebarFullWidthOnMobileLayout from "../../../Layout/SecondarySidebarFullWidthOnMobileLayout";
const MAX_TEMPLATES = 10;
const MessageTemplateSecondarySidebar = (props) => {
    const location = useLocation();
    // Use Params to get the search query for the template list
    const params = useParams();
    const searchQuery = params.searchQuery;
    const [templatesState, loadTemplates, templatesStateActions] = useService(MessageService.getMessageTemplates);
    const [loadNextPageState, loadNextPageInternal] = useService(MessageService.getMessageTemplates);
    /**
     * Making sure we allow the user to switch to fullscreen
     * */
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [isMobileFullScreen, setIsMobileFullScreen] = useState(false);
    /**
     * Creating ref for the Page Number
     * */
    const pageNumber = useRef(0);
    const loadNextPage = () => {
        pageNumber.current += 1;
        loadNextPageInternal({
            max: MAX_TEMPLATES,
            offset: pageNumber.current * MAX_TEMPLATES,
            query: searchQuery,
        }).then((response) => {
            var _a;
            templatesStateActions.edit(Object.assign(Object.assign({}, response), { data: (((_a = templatesState.data) === null || _a === void 0 ? void 0 : _a.data) || []).concat(response.data) }));
        });
    };
    /**
     * Any time user searches anything or the unread checkbox is changed,
     * we will load the messages and initialize page to 0
     * */
    useEffect(() => {
        pageNumber.current = 0;
        loadTemplates({
            query: searchQuery,
            max: MAX_TEMPLATES,
        });
    }, [loadTemplates, searchQuery]);
    const loadSidebar = () => {
        pageNumber.current = 0;
        loadTemplates({
            query: searchQuery,
            max: MAX_TEMPLATES,
        });
    };
    // @ts-expect-error - TS7006 - Parameter 'messages' implicitly has an 'any' type.
    const renderLoadMoreButton = (messages) => {
        const hasPages = templatesState.data &&
            templatesState.data.data.length > 0 &&
            templatesState.data.data.length < templatesState.data.total;
        if (messages.data.length > 0 && hasPages) {
            return (_jsxs("button", { className: "list-group-item list-group-item-action bg-light text-center clickable", onClick: loadNextPage, title: "Load more", disabled: loadNextPageState.isLoading, children: ["Load more", loadNextPageState.isLoading && _jsx(Loading, { className: "ml-2" })] }));
        }
        return null;
    };
    const locationSplitArr = location.pathname.split("/");
    const locationTemplateId = locationSplitArr[locationSplitArr.length - 1] || "";
    return (
    // @ts-expect-error - TS2786 - 'SecondarySidebarFullWidthOnMobileLayout' cannot be used as a JSX component.
    _jsx(SecondarySidebarFullWidthOnMobileLayout, { contentFullScreen: isFullScreen, contentMobileFullScreen: isMobileFullScreen, sidebar: _jsx(SecondaryNavLayout, { nav: _jsxs("div", { className: "d-flex w-100 align-items-center justify-content-between", children: [_jsxs("span", { children: [(templatesState.data && templatesState.data.total) || 0, " ", "Templates"] }), _jsx("span", { children: _jsxs(Link, { className: "btn btn-link", title: "Create a new template", to: getMessageTemplateNewPath(), children: [_jsx(FAIcon, { icon: "plus", addMarginRight: true }), "New", _jsx("span", { className: "sr-only", children: "Create a new template" })] }) })] }), children: _jsx("div", { className: "custom-scrollbar fullHeightMinusSecondaryNav touch-scroll bg-light", style: { overflowY: "auto" }, children: _jsxs("div", { className: "list-group list-group-flush border-bottom", children: [_jsx("div", { className: "list-group-item border-top-0 py-2 px-1 d-flex align-items-end flex-column bg-light", children: _jsx(SearchWithQuery, { value: searchQuery, paramLabel: "searchQuery", title: "Search by Name", ariaLabel: "Search", placeholder: "Search by Name", type: "search" }) }), _jsx(ServiceResult, { state: templatesState, children: (templates) => (_jsxs(_Fragment, { children: [templates.data.length === 0 && (_jsxs("div", { className: "list-group-item", children: [_jsx("div", { className: "text-center w-100 my-2", children: "No Templates." }), _jsx("div", { className: "d-flex justify-content-center", children: _jsx("div", { children: _jsxs(Link, { to: getMessageTemplateNewPath(), className: "btn btn-sm btn-primary mt-2", children: [_jsx(FAIcon, { icon: "plus", addMarginRight: true }), "Create One"] }) }) })] })), templates.data.map((template) => (_jsx(Link, { to: getMessageTemplateDetailView({ id: template.id }), className: `list-group-item list-group-item-action d-flex flex-column ${locationTemplateId === template.id ? "active" : ""}`, children: template.name }, template.id))), loadNextPageState.hasError && (_jsx(AlertError, { className: "mb-0", message: "There was an error loading more templates" })), renderLoadMoreButton(templates)] })) })] }) }) }), large: true, children: props.children(isFullScreen, setIsFullScreen, setIsMobileFullScreen, loadSidebar) }));
};
export default MessageTemplateSecondarySidebar;
